import { useEffect } from "react";
import Lenis from "lenis";
import { useIsMobile } from "@/hooks/useIsMobile";

// Lenis drives a requestAnimationFrame loop that runs forever, on every
// page, whether or not the user is actively scrolling — it's the single
// biggest continuous main-thread cost on the site. Desktop keeps the
// smoothed/lerp'd scroll feel; mobile/tablet (≤1024px) falls back to the
// browser's own native scrolling, which is already smooth (OS-level
// momentum scrolling) and costs nothing extra.
export function SmoothScroll({ children }) {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile) return;

    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let rafId;

    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, [isMobile]);

  return children;
}
